import { Controller } from '@hotwired/stimulus';

export default class LoadingSpinnerTimerController extends Controller {
  static targets = ['spinner'];

  connect() {
    setTimeout(() => {
      this.spinnerTarget.classList.add('is-hidden');
    }, 3000);
  }
}
